import React, { FC, ReactElement } from 'react';
import { WarningRounded } from '@mui/icons-material';
import { ErrorBoundaryProps } from './constants/errorBoundary.interface';
import cn from 'utils/cn';

interface Props extends ErrorBoundaryProps {
  children: ReactElement<any>;
}

const ErrorMessage: FC<Props> = ({
  testId,
  containerProps,
  errorMessageProps,
  children,
}): ReactElement<any> => {
  return (
    <div
      data-testid={testId || 'error-message'}
      className={cn(
        'tw:flex tw:flex-col tw:items-center',
        containerProps?.className ? containerProps.className : 'tw:mt-8 tw:text-xl'
      )}
    >
      <WarningRounded style={{ color: '#CC3300', fontSize: 64 }} />
      <div
        className="tw:mt-4 tw:font-light"
        style={{
          lineHeight: '31px',
          width: errorMessageProps?.style?.width ? errorMessageProps.style?.width : undefined,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ErrorMessage;
